// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const AuthInterceptor = function(
   this: any,
   $rootScope: any,
   $q: any,
   $injector: any,
   $authEvents: any,
   $log: any
) {
   // we could also use a magic header (check for config.header.Sierra == true, and then add Bearer stuff)
   // or use $resource for Sierra calls and add it there, and check for /auth/
   this.$rootScope = $rootScope
   this.$q = $q
   this.$authEvents = $authEvents
   this.$log = $log
   return {
      request: (config: any) => {
         // this injector thing fixes circular dependency on $http...
         const authenticationService = $injector.get('authenticationService')

         if (!authenticationService.scope.samlForPrivateSite && 
            (config.url.indexOf('/auth/') === -1) && 
            (config.url.indexOf('/sierra_api/') === -1) && 
            (config.url.indexOf('/save-search') === -1) &&
            (config.url.indexOf('/save-item') === -1) &&
            (config.url.indexOf('/api') === -1)) {
            // not a request to authenticated source, continue
            return config
         }

         let provider = ''
         if (config.url.indexOf('/auth/') === 0) {
            const providerMatch = /\/auth\/([^\/]+)\//.exec(config.url)

            if (providerMatch && (providerMatch.length > 1)) {
               provider = providerMatch[1]
            }

         } else if (config.url.indexOf('/sierra_api/') === 0) {
            provider = authenticationService.getLoggedInProviderForFeature('sierra')

         } else if (config.url.indexOf('/save-search/') === 0 || (config.url.indexOf('/save-item') === 0) ) {
            provider = authenticationService.getLoggedInProviderForFeature('cloudStorage')
         } else if (config.url.indexOf('/api/') === 0) {
            provider = authenticationService.getLoggedInProviderForFeature('searchapi') || 'saml'
         } 

         // no provider found, not performing request interception
         if (!provider) {
            return config
         }

         // add provider as header so we can handle that when checking authentication
         config.headers = config.headers || {}
         config.headers['X-Provider'] = provider

         const csrf = authenticationService.getAuthValue(provider, 'csrf')

         if (!csrf) {
            return config
         }

         const deferred = this.$q.defer()
         // do not run doRefreshToken /auth/refresh, since that might cause a loop where it's calling the refresh endpoint due to doRefreshToken call
         if (config.url.indexOf(`/auth/${provider}/refresh`) === -1) {
            authenticationService.doRefreshToken(provider)
               .then(() => {
                  config.headers = config.headers || {}
                  config.headers['X-CSRF-Token'] = authenticationService.getAuthValue(provider, 'csrf') // pass the NEW csrf token to verify we made the call
                  return deferred.resolve(config)
               }).catch((err: any) => {
                  return deferred.reject({config, error: err, errorMessage: 'Failed to refresh token'})
               })
         } else {
            config.headers = config.headers || {}
            config.headers['X-CSRF-Token'] = csrf // pass the csrf token to verify we made the call
            deferred.resolve(config)
         }

         return deferred.promise
      },

      responseError: (rejection: any) => {
         // this injector thing fixes circular dependency on $http...
         let authenticationService = $injector.get('authenticationService')
         const url = rejection.config?.url || ''
         if (!url) {
            return rejection
         }

         if (!authenticationService.scope.samlForPrivateSite && (url.indexOf('/auth/') === -1) && (url.indexOf('/sierra_api/') === -1) && (url.indexOf('/save-search/') === -1) && (url.indexOf('/save-item') === -1) ) {
            // not a request to authenticated source, continue
            return rejection
         }

         let provider = ''
         if (url.indexOf('/auth/') === 0) {
            const providerMatch = /\/auth\/([^\/]+)\//.exec(url)

            if (providerMatch && (providerMatch.length > 1)) {
               provider = providerMatch[1]
            }

         } else if (url.indexOf('/sierra_api/') === 0) {
            // get provider whose login was leveraged for endpoint
            provider = authenticationService.getLoggedInProviderForFeature('sierra')

    
         } else if (url.indexOf('/save-search/') === 0 || url.indexOf('/save-item') === 0 ) {
            // get provider whose login was leveraged for endpoint
            provider = authenticationService.getLoggedInProviderForFeature('cloudStorage')
         }


         const deferred = this.$q.defer()
         if (rejection.status === 401 && provider != 'lti' && !(provider == 'saml' && authenticationService.scope.samlForPrivateSite)) { // reject either way but no need for red alert w/ lti and saml since user may not have asked to sign in
            this.$log.debug(`Interceptor found 401 error for ${url}, emiting notauthenticated event. Provider: ${provider}`)
            this.$rootScope.$broadcast(this.$authEvents.NOTAUTHENTICATED, {redirectUri: url, provider})
            // This does return an error with original content, but also broadcasts event that can trigger a dialog popup or error message
            return this.$q.reject(rejection)
         } else {
            return this.$q.reject(rejection)
         }
      }
   }
}

angular.module('summonApp.factories')
   .factory('authInterceptor', ['$rootScope', '$q', '$injector', '$authEvents', '$log', AuthInterceptor])
